window.app = window.app || {};

window.app.modal = {
  body: document.querySelector('body'),
  modals: document.querySelectorAll('.mt-modal'),
  modalsIds: [],
  modalVisible: false,

  open: function(modal = null) {
    if (modal === null || this.modalVisible) return;

    modal.classList.add('visible');
    this.body.classList.add('mt-modal-active');
    this.modalVisible = true;
  },

  close: function(modal = null) {
    if (modal === null) return;

    modal.classList.remove('visible');
    this.body.classList.remove('mt-modal-active');
    this.modalVisible = false;
  },

  comparePlans: function() {
    const el = {
      slider: document.querySelector('.mt-compare-plans__list .swiper'),
      shortDescriptions: document.querySelectorAll('.mt-plan__short-description')
    };
    const sliderConfig = {
      slidesPerView: 1,
      spaceBetween: 8,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      }
    };
    const updateDescHeight = () => {
      let minHeight = 0;
      el.shortDescriptions.forEach(desc => {
        desc.style.minHeight = 0;
        (desc.offsetHeight > minHeight) && (minHeight = desc.offsetHeight);
      });
      el.shortDescriptions.forEach(desc => (desc.style.minHeight = `${minHeight}px`));
    };
    let slider;
    
    updateDescHeight();
    (window.innerWidth <= 768) && (slider = new Swiper(el.slider, sliderConfig));
    window.addEventListener('resize', () => {
      updateDescHeight();
      if (window.innerWidth <= 768 && !slider) {
        slider = new Swiper(el.slider, sliderConfig);
      } else if (window.innerWidth > 768 && slider) {
        slider.destroy(true, true);
        slider = null;
      }
    });
  },

  init: function() {
    const _this = this;
    if (_this.modals.length === 0) return;

    _this.modals.forEach(modal => {
      const el = {
        overlay: modal.querySelector('.mt-modal__overlay'),
        close: modal.querySelector('.mt-modal-close')
      };

      // Get modal ID
      (modal.id != '') && _this.modalsIds.push(modal.id);

      // Events
      [el.overlay, el.close].forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault();
          _this.close(modal);
        });
      });
      modal.addEventListener('keydown', e => {
        e = e || window.event;
        if (e.keyCode === 27) {
          _this.close(modal);
        }
      });

      // Compare Plans
      (modal.id == 'compare-plans') && _this.comparePlans();
    });

    // Open modal via links
    document.addEventListener('click', e => {
      const closestLink = e.target.closest('a');
      if (e.target.matches('[href^="#"]') || closestLink?.matches('[href^="#"]')) {
        const modalId = (e.target.hash || closestLink?.hash).replace('#', '');
        const modal = document.getElementById(modalId);
    
        if (modal && _this.modalsIds.includes(modalId)) {
          e.preventDefault();
          _this.open(modal);
        }
      }
    });

    // Close modals with keyboard
    document.addEventListener('keydown', e => {
      const activeModal = document.querySelector('.mt-modal.visible');
      (e.key === 'Escape' && activeModal) && _this.close(activeModal);

      if (activeModal && activeModal.id === 'activity-modal') {
        const gallery = document.querySelector('.mt-activity-gallery');
        (e.key == 'ArrowRight') && gallery.swiper?.slideNext();
        (e.key == 'ArrowLeft') && gallery.swiper?.slidePrev();
      }
    });
  }
}
window.app.modal.init();